'use strict';

/* Views */
import CalendarEdit from './edit/calendar-edit.component';
import CalendarList from './list/calendar-list.component';

/* Components */
import CalendarDetailComponent from '../../components/calendar/detail/calendar-event-detail.component';

/* Services */
import CalendarEventService from '../../components/calendar/event.service';

export default angular.module('conduuApp.calendar', [CalendarEdit, CalendarList, CalendarDetailComponent, CalendarEventService])
  .name;



// WEBPACK FOOTER //
// ./client/app/calendar/index.js